import axios from 'axios';
import config from '../../config';
import user from '../user';
import tenant from '../tenant';
import { ERROR_CODE, needLoginCodes } from './constant';
import utils from '../utils';
import auth from 'services/auth';
import { message } from 'antd';

const axiosInstance = axios.create({
  baseURL: config.API_URL,
  timeout: 30000,
  headers: { 'x-header-tid': tenant.getTenantId() }
});

let isRefreshing = false;
let requests: any[] = [];

// 处理responseType是blob类型的响应
const interceptorsResponse = (response: any) => {
  const contentType = 'text/plain;charset=UTF-8';
  const responseType = 'blob';
  const { data } = response;
  if (
    typeof response.request.responseType === 'string' &&
    response.request.responseType.toLocaleLowerCase() === responseType
  ) {
    if (response.headers['content-type'] === contentType) {
      let reader: any = new FileReader();
      reader.readAsText(data);
      return new Promise(resolve => {
        reader.onload = (e: any) => {
          resolve(JSON.parse(e.target.result));
        };
      });
    }
  }
  return data;
};
axiosInstance.interceptors.request.use(
  function (config) {
    config.headers['x-header-token'] = user.getToken();
    return config;
  },
  function (error) {
    return Promise.reject(error);
  }
);
axiosInstance.interceptors.response.use(
  async function (response) {
    const { data } = response;
    const { code, success } = await interceptorsResponse(response);
    if (needLoginCodes.includes(code)) {
      utils.goLogin();
      return data;
    }
    if (code === ERROR_CODE.TOKEN_OVERTIME) {
      const { config } = response;
      if (isRefreshing) {
        return new Promise(resolve => {
          requests.push(() => {
            config.headers['x-header-token'] = user.getToken();
            resolve(axiosInstance(config));
          });
        });
      } else {
        isRefreshing = true;
        const res = await auth.refreshToken();
        const { data, success } = res;
        isRefreshing = false;
        if (success) {
          user.setToken(data);
          requests.forEach(cb => cb());
          requests = [];
          return axiosInstance(config);
        } else {
          user.removeToken();
          utils.goLogin();
        }
        requests = [];
        return res;
      }
    }
    if (success === false) {
      let errorMessage = data.message;
      message.error(errorMessage);
    }
    return data;
  },
  function (error) {
    return {
      success: false
    };
  }
);
export default axiosInstance;
